import { render, staticRenderFns } from "./RateCardRateEditForm.vue?vue&type=template&id=1a412db6&"
import script from "./RateCardRateEditForm.vue?vue&type=script&lang=js&"
export * from "./RateCardRateEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports